import React from 'react';
import Home from './Components/Home/Home';
import IconButton from '@mui/material/IconButton';
import { Container } from '@mui/material';





function App() {
  return (
    <div className="App">
      <Container>
        <Home />
      </Container>
    </div>
  );
}

export default App;
